import React, { useContext, useMemo } from 'react';
import useAccountRoles from '@ubeya/shared/hooks/account/useAccountRoles';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const AccountRoleChip = ({ value }) => {
  const { mappedAccountRoles } = useAccountRoles();
  const { t } = useContext(ConfigContext);

  const mappedAccountRolesWithCustom = useMemo(() => {
    return {
      ...mappedAccountRoles,
      [-1]: { name: t('custom') }
    };
  }, [mappedAccountRoles, t]);

  if (!Array.isArray(value)) {
    return <FlexMiddle>{mappedAccountRolesWithCustom[value]?.name || value}</FlexMiddle>;
  }

  return (
    <FlexMiddle>
      {value
        .map((item) => mappedAccountRolesWithCustom[item]?.name)
        .filter(Boolean)
        .join(', ')}
    </FlexMiddle>
  );
};

export default AccountRoleChip;
